// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Appointment view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...AppointmentRender }`, [AppointmentRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const AppointmentRenderFragment = graphql(`
  fragment AppointmentRender on Appointment @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    status
    cancelationReason {
      text
      coding {
        system
        code
        display
      }
    }
    serviceCategory {
      text
      coding {
        system
        code
        display
      }
    }
    serviceType {
      text
      coding {
        system
        code
        display
      }
    }
    specialty {
      text
      coding {
        system
        code
        display
      }
    }
    appointmentType {
      text
      coding {
        system
        code
        display
      }
    }
    reasonCode {
      text
      coding {
        system
        code
        display
      }
    }
    reasonReference {
      reference
      type
      display
    }
    priority
    description
    supportingInformation {
      reference
      type
      display
    }
    start
    end
    minutesDuration
    slot {
      reference
      type
      display
    }
    created
    comment
    patientInstruction
    basedOn {
      reference
      type
      display
    }
    participant {
      type {
        text
        coding {
          system
          code
          display
        }
      }
      actor {
        reference
        type
        display
      }
      required
      status
      period {
        start
        end
      }
    }
    requestedPeriod {
      start
      end
    }
  }
`);
